export default __webpack_public_path__ + "static/media/marketplace-pet.558bbe7e.jpg";